<template>
    <div class="one-bd clearfix">
        <div class="fl">
            <router-link to="/personalCenter" exact>会员权益</router-link>
            <router-link to="/personalCenter/permissionComparison" v-if="$parent.$parent.vipInfo.level != 20">会员购买</router-link>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
           
        }
    },
    mounted() {
		let that = this;
    },
    created() {
		
    },
    methods: {
       
       
	}
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/vipMenu.vue